import { FC } from 'react';
import { ProgressSpinner } from '../atoms/ProgressSpinner';

type LoadingSpinnerProps = {
  size?: number;
  className?: string;
};

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 100, className = '' }) => {
  return (
    <div className={`flex h-full w-full items-center justify-center ${className}`}>
      <ProgressSpinner style={{ width: `${size}px`, height: `${size}px` }} strokeWidth="4" animationDuration="1.5s" />
    </div>
  );
};
